import { gql } from '@apollo/client';

const CREDENTIALS = `
  credentials {
    accessToken
    client
    expiry
    tokenType
    uid
  }
`;

export const ACCEPT_INVITATION = gql`
  mutation UserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $invitationToken: String!
  ) {
    userAcceptInvitation(
      password: $password
      passwordConfirmation: $passwordConfirmation
      invitationToken: $invitationToken
    ) {
      ${CREDENTIALS}
    }
  }
`;

export const LOGIN = gql`
  mutation Login(
    $email: String!
    $password: String!
  ) {
    userLogin(
      email: $email
      password: $password
    ) {
      ${CREDENTIALS}
    }
  }
`;

export const SEND_PASSWORD_RESET = gql`
  mutation UserSendPasswordResetWithToken(
    $email: String!
  ) {
    userSendPasswordResetWithToken(
      email: $email
      redirectUrl: "https://equplinc.com"
    ) {
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation UserUpdatePasswordWithToken(
    $password: String!
    $passwordConfirmation: String!
    $resetPasswordToken: String!
  ) {
    userUpdatePasswordWithToken(
      password: $password
      passwordConfirmation: $passwordConfirmation
      resetPasswordToken: $resetPasswordToken
    ) {
      ${CREDENTIALS}
    }
  }
`;
